import React from 'react'
import ExcelUpload from '../../components/common/excel-upload/excel-upload'

const BlokajEkle = () => {
    return (
        <>
            <ExcelUpload
                role_name="genel_blokaj_write"
                requiredColumnsSase={[
                    "sase", "action", "Telep Eden Bayi", "Aciklamas"
                ]}
                exampleData={[{
                    sase: "VR1JCYHZUPY572549",
                    action: "EKLE",
                    "Telep Eden Bayi": "UK",
                    Aciklamas: "Blokaj Eklendi"
                },
                {
                    sase: "VR1JCYHZUPY572549",
                    action: "KALDIR",
                    "Telep Eden Bayi": "UK",
                    Aciklamas: "Blokaj Silindi"
                }]}
                process_type="BLOCKING"
                ExcelName={"Hatalı Blokaj Verileri"}
                Title={"Blokaj Ekle"}
            />
        </>
    )
}

export default BlokajEkle